import script from "./index-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-web.vue?vue&type=script&lang=ts&setup=true"

import "./index-web.vue?vue&type=style&index=0&id=b8cccd02&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8cccd02"]])

export default __exports__